import { request } from '~/utils/request'

export const actions = {
  async fetchList({ state }) {
    const { data } = await request(this).get('/alerts')
    return data
  },
}
